// TradingViewWidget.jsx
import React, { useEffect, useRef } from "react"

function TradingViewWidget({ symbol }: { symbol: string }) {
    const container = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const currentContainer = container.current

        const script = document.createElement("script")
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js"
        script.type = "text/javascript"
        script.async = true
        script.innerHTML = `
        {
          "autosize": true,
          "symbol": "BYBIT:${symbol}T.P",
          "interval": "D",
          "timezone": "Etc/UTC",
          "theme": "dark",
          "style": "1",
          "locale": "en",
          "backgroundColor": "rgba(0, 0, 0, 1)",
          "hide_legend": true,
          "allow_symbol_change": false,
          "save_image": false,
          "calendar": false,
          "support_host": "https://www.tradingview.com"
        }`

        // Clear the container before appending the new script
        if (currentContainer) {
            currentContainer.innerHTML = ""
            currentContainer.appendChild(script)
        }

        // Cleanup function to remove the script when component unmounts or symbol changes
        return () => {
            if (currentContainer) {
                currentContainer.innerHTML = ""
            }
        }
    }, [symbol])

    return (
        <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%" }}>
            <div
                className="tradingview-widget-container__widget"
                style={{ height: "calc(100% - 32px)", width: "100%" }}
            ></div>
            <div className="tradingview-widget-copyright">
                <a href="https://www.tradingview.com/" rel="noopener nofollow noreferrer" target="_blank">
                    <span className="blue-text">Track all markets on TradingView</span>
                </a>
            </div>
        </div>
    )
}

export default TradingViewWidget
